/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './ActionTypes';

//current Quarter
const currentDate = new Date();
const currentMonth = currentDate.getMonth() + 1; // Month is zero-indexed, so add 1
const currentYear = currentDate.getFullYear();
const currentQuarter = Math.ceil(currentMonth / 3); // Divide the current month by 3 and round up to get the current quarter
const formattedQuarter = currentQuarter + 'Q' + currentYear.toString();
const initialState = {
  planType: [],
  rebateProgram: [],
  selectedPlanType: '',
  rebateProgramName: {},
  allRebateProgram: false,
  isLoading: false,
  isAllManufacturersSelected: true,
  errorMessages: [],
  manufacturerList: [],
  headerSearchResult: [],
  searchResult: [],
  manufacturerSelected: [],
  selectRowIndex: null,
  planTypeToggle: '',
  quarterValue: formattedQuarter,
  exportAllData: {},

  displayObj: {
    rebateProgramName: '',
    allRebateProgram: false,
    quarterValue: '',
    manufacturerSelected: [],
    searchResult: [],
    headerSearchResult: [],
    rebateProgrameName: '',
    countValue: 1,
  },
};
export const reducer = (state = initialState, Actions) => {
  switch (Actions.type) {
    //Plan type and rebate program
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: Actions.payload };
    // case ActionTypes.GET_REBATE_PROGRAM:
    //   return { ...state, rebateProgram: Actions.payload };
    case ActionTypes.GET_ERROR_MSG_MFG_OUTSTANDING_BALANCE:
      return { ...state, errorMessages: Actions.payload };
    case ActionTypes.SELECTED_MFG_OUT_BAL_MFG:
      return { ...state, mfgListSelected: Actions.payload };
    //Manufacturer Grid
    case ActionTypes.GET_MANUFACTURERS_OUTSTANDING_DISPUTES_QUARTER:
      return { ...state, manufacturerList: Actions.manufacturerList };

    //To pass the selected option from req screen to disp screen
    case ActionTypes.SET_SELECTED_RESULT_MFG_OUTSTANDING_BALANCE:
      return { ...state, ...Actions.payload };

    //For Search Screen Header
    case ActionTypes.SET_MANUFACTURER_OUSTANDING_BALANCE_HEADER:
      return {
        ...state,
        headerSearchResult: Actions.payload,
      };

    case ActionTypes.SET_MANUFACTURER_OUSTANDING_BALANCE_REPORT:
      let displayObj = {
        ...state.displayObj,
        searchResult: Actions.payload,
      };
      return { ...state, searchResult: Actions.payload, displayObj };

    //loader
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: Actions.isLoading };
    //refresh
    case ActionTypes.REFRESH_MFG_OUTSTANDING_BALANCE:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.REFRESH_MFG_OUTSTANDING_BALANCE_DISPLAY:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.SET_PAGINATION_INDEX_MANUFACTURER_OUSTANDING_BALANCE:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: Actions.payload },
      };
    //export all
    case ActionTypes.SET_EXPORT_ALL_PDF_MFGO_OUTSTANTING_BAL:
      const { data, rebateProgram } = Actions.payload;
      const exportAllData =
        rebateProgram === 'noData'
          ? {}
          : { ...state.exportAllData, [rebateProgram]: data };
      return {
        ...state,
        exportAllData,
      };

    default:
      return state;
  }
};

export default reducer;
